import React, { useState } from 'react';
import templates from './discoveryTemplates.json';

// Group templates by theme
const grouped = templates.reduce((acc, t) => {
  if (!acc[t.theme]) acc[t.theme] = [];
  acc[t.theme].push(t);
  return acc;
}, {});

const THEME_ORDER = [
  'Multi-Practice',
  'Manual Invoicing',
  'Pay & Disputes',
  'Month-End Stress',
  'GDC & Compliance',
  'Career & Growth',
  'Tax & Self-Assessment',
  'Locum Life',
  'NHS vs Private',
  'Work-Life Balance',
  'New to the Profession',
  'Brand Awareness',
];

const DiscoveryCreatives = ({ onTemplateSelect, selectedTemplateId }) => {
  const [openTheme, setOpenTheme] = useState('Multi-Practice');

  const handleSelect = (template) => {
    if (onTemplateSelect) onTemplateSelect(template);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: '#e2e8f0', marginBottom: 4 }}>
          Discovery Creatives
        </div>
        <div style={{ fontSize: 12, color: '#94a3b8', lineHeight: 1.5 }}>
          15 curated brand-awareness posts targeting real hygienist pain points.
          Pick a theme, select a template, then tweak copy and export.
        </div>
      </div>

      {THEME_ORDER.filter(t => grouped[t]).map(theme => (
        <div key={theme} style={{ marginBottom: 4 }}>
          {/* Theme accordion header */}
          <button
            onClick={() => setOpenTheme(openTheme === theme ? null : theme)}
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: openTheme === theme ? '#1e293b' : '#0f172a',
              border: '1px solid #334155',
              borderRadius: openTheme === theme ? '8px 8px 0 0' : 8,
              padding: '10px 14px',
              cursor: 'pointer',
              color: '#e2e8f0',
              fontWeight: 600,
              fontSize: 13,
              transition: 'background 0.15s',
            }}
          >
            <span>
              {grouped[theme][0]?.emoji} {theme}
              <span style={{ marginLeft: 8, color: '#64748b', fontWeight: 400 }}>
                ({grouped[theme].length})
              </span>
            </span>
            <span style={{ color: '#64748b', fontSize: 16, lineHeight: 1 }}>
              {openTheme === theme ? '▲' : '▼'}
            </span>
          </button>

          {/* Templates within theme */}
          {openTheme === theme && (
            <div style={{
              border: '1px solid #334155',
              borderTop: 'none',
              borderRadius: '0 0 8px 8px',
              background: '#0f172a',
              overflow: 'hidden',
              marginBottom: 2,
            }}>
              {grouped[theme].map((tpl, idx) => {
                const isSelected = selectedTemplateId === tpl.id;
                return (
                  <button
                    key={tpl.id}
                    onClick={() => handleSelect(tpl)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      background: isSelected ? '#1e3a8a' : idx % 2 === 0 ? '#0f172a' : '#111827',
                      border: 'none',
                      borderTop: idx > 0 ? '1px solid #1e293b' : 'none',
                      padding: '12px 14px 10px 14px',
                      cursor: 'pointer',
                      transition: 'background 0.12s',
                      outline: isSelected ? '2px solid #3b82f6' : 'none',
                      outlineOffset: -2,
                    }}
                    onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#1e293b'; }}
                    onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = idx % 2 === 0 ? '#0f172a' : '#111827'; }}
                  >
                    {/* Gradient pill preview */}
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                      <div style={{
                        width: 36,
                        height: 36,
                        borderRadius: 6,
                        background: tpl.gradientOverlay,
                        flexShrink: 0,
                        marginTop: 2,
                      }} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                          fontWeight: 700,
                          fontSize: 13,
                          color: isSelected ? '#93c5fd' : '#e2e8f0',
                          lineHeight: 1.3,
                          marginBottom: 3,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                          {tpl.mainHeading}
                        </div>
                        <div style={{
                          fontSize: 11,
                          color: '#94a3b8',
                          lineHeight: 1.4,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}>
                          {tpl.taglineText}
                        </div>
                        {isSelected && (
                          <div style={{ marginTop: 5 }}>
                            <span style={{
                              background: '#1d4ed8',
                              color: '#bfdbfe',
                              fontSize: 10,
                              padding: '2px 8px',
                              borderRadius: 20,
                              fontWeight: 600,
                            }}>
                              ✓ Applied to canvas
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}

      <div style={{ marginTop: 12, padding: '10px 12px', background: '#0f2a1a', border: '1px solid #14532d', borderRadius: 8 }}>
        <div style={{ fontSize: 11, color: '#86efac', lineHeight: 1.6 }}>
          💡 <strong>Tip:</strong> After selecting a template, use the right panel to tweak the copy,
          swap the background image, and adjust colours before exporting.
        </div>
      </div>
    </div>
  );
};

export default DiscoveryCreatives;
